import { Component, Output, EventEmitter, Input } from '@angular/core';
import { environment } from '@base/environments/environment';
import { LogedUser } from '@base/src/app/core/models/logged-user.model';
import { Cashflow } from '@base/src/app/pages/configuration/panel/configuration.component';
import { UtilsService } from '@base/src/app/services/utils.service';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';

@Component({
  selector: 'app-cashflows',
  templateUrl: './cashflows.component.html',
  styleUrls: ['./cashflows.component.scss'],
})
export class CashflowsComponent {
  @Input() cashflows: Cashflow[] = [];
  @Output() onAction: EventEmitter<any> = new EventEmitter<any>();

  userCashflows: { key: string; value: boolean }[] = [];
  filteredCashflows: Cashflow[] = [];

  loggedUserSubscription: Subscription | undefined;
  loggedUser: LogedUser | undefined;

  buttonEdit: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.PENCIL_BLUE,
    iconOnly: true,
  };

  NODE = environment.node;
  NODE_AR = Constants.TENANT_ID_AR;
  NODE_EC = Constants.TENANT_ID_EC;
  NODE_PY = Constants.TENANT_ID_PY;

  isLoading = true;

  constructor(private readonly utilService: UtilsService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.generateCashflowsPermissions();
  }

  onEdit(type: number) {
    this.onAction.emit(type);
  }

  generateCashflowsPermissions() {
    const USER = this.utilService.getLoggedUser();

    const PERMISSIONS = [
      USER?.security.movements_custom_cash_flow,
      USER?.security.movements_custom_cash_flow_2,
      USER?.security.movements_custom_cash_flow_3,
      USER?.security.movements_custom_cash_flow_4,
      USER?.security.movements_custom_cash_flow_5,
      USER?.security.movements_custom_cash_flow_6,
    ];

    this.cashflows = this.cashflows.filter((e) => {
      if (e.type >= 6 && e.type <= 11) {
        const NEW_INDEX = e.type - 6;
        return PERMISSIONS[NEW_INDEX];
      }
      return true;
    });

    this.isLoading = false;
  }
}
